import {
  SET_SELECTED_SEGMENTATION,
  SET_SEGMENTATIONS,
  ADD_SEGMENTATION,
  UPDATE_SEGMENTATION,
  REMOVE_SEGMENTATION
} from '../actions/types';

const initialState = {
  segmentation: null,
  segmentations: [],
};

const segmentationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_SEGMENTATION:
      return {
        ...state,
        segmentation: action.data,
      };
    case SET_SEGMENTATIONS:
      return {
        ...state,
        segmentations: action.data,
      };
    case ADD_SEGMENTATION:
      return {
        ...state,
        segmentations: [...state.segmentations, action.data],
      };
    case UPDATE_SEGMENTATION:
      return {
        ...state,
        segmentations: state.segmentations.map(seg =>
          seg.id === action.data.id ? action.data : seg
        ),
        // Update selected segmentation if it was updated
        segmentation: state.segmentation?.id === action.data.id ? action.data : state.segmentation,
      };
    case REMOVE_SEGMENTATION:
      return {
        ...state,
        segmentations: state.segmentations.filter(seg => seg.id !== action.data),
        // Clear selected segmentation if it was deleted
        segmentation: state.segmentation?.id === action.data ? null : state.segmentation,
      };
    default:
      return state;
  }
};

export default segmentationReducer;
